module.exports = __webpack_public_path__ + "img/company_logo_helmet.98bc2e92.svg";